function initDynamicHeaderHeightAdjustment() {
    console.log('adjust dyheight for all page');
    let headercontainer = document.querySelector('.header-container.no-padding.style-1');
    let headernavi = document.querySelector('.header-navigation.d-none.d-lg-block.no-padding');

    function updateHeaderDynamicHeight() {
      const headerHeight = headercontainer.clientHeight;
      let naviHeight = headernavi.clientHeight;
      let dyheight = naviHeight - headerHeight + 'px';

      if (naviHeight === 0) {
        dyheight = '0px';
      }

      document.documentElement.style.setProperty('--header-down-dyheight', dyheight);
      // console.log('set dyheight to :'+ dyheight);
    }

    // Initialize the dynamic height once and set up event listeners
    updateHeaderDynamicHeight();
    window.addEventListener('resize', updateHeaderDynamicHeight);
    window.addEventListener('scroll', updateHeaderDynamicHeight);
  }
    
  window.onload = function() {
    initDynamicHeaderHeightAdjustment();
  };